import ChannelFeatureEpisodesGrid from "@/components/ChannelFeatureEpisodesGrid";
import Loading from "@/components/Loading";
import ChannelFeaturedMetaTags from "@/components/MetaTags/ChannelFeaturedMetaTags";
import { useBreadcrumbs, useChannelDetailQuery } from "@/hooks";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var __N_SSP = true;
export default function ChannelDetailFeatured() {
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const router = useRouter();
  const id = parseInt(router.query.id, 10);
  const {
    loading,
    data
  } = useChannelDetailQuery({
    variables: {
      id
    }
  });
  const channel = data === null || data === void 0 ? void 0 : data.channel;
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: "月額商品一覧",
      href: routes.channels
    }, {
      text: channel.name,
      href: routes.channelDetail(channel.id)
    }, {
      text: "注目の番組"
    }]);
  }, [channel]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), /*#__PURE__*/_jsx(ChannelFeaturedMetaTags, {
      channel: channel
    }), /*#__PURE__*/_jsx(ChannelFeatureEpisodesGrid, {
      header: {
        text: `${channel.name}の注目の番組`
      },
      id: id
    })]
  });
}